import { isEmpty } from 'lodash';
import { translate } from '@fiverr-private/i18n-react';
import { ROLES_SLIDING_CAROUSEL_HEIGHT } from '../RolesCarousel/constants';
import { DYNAMIC_GIG_CARD_CAROUSEL_HEIGHT } from '../gigs/DynamicGigCardCarouselWrapper/constants';
import { carouselNameToExcludedBadges } from './constants';

export const getSubCategoryName = (scId, nestedScId) =>
    nestedScId
        ? translate(`sub_categories.sub_category_${scId}.nested_sub_cat_${nestedScId}.name`)
        : translate(`sub_categories.sub_category_${scId}.name`);

export const convertLeanPropertiesToTitleSections = (component) => {
    const leanProperties = component?.lean_properties;
    const properties = component?.properties;
    const isValidLeanProperties = !isEmpty(leanProperties) && isEmpty(properties);

    if (isValidLeanProperties) {
        const { title, sub_category_id, nested_sub_category_id, component_data_source } = leanProperties;
        const isScTitle = sub_category_id || nested_sub_category_id;
        const metadata = {};

        if (isScTitle) {
            metadata.service_id = nested_sub_category_id || sub_category_id;
        }

        if (component_data_source) {
            metadata.component_data_source = component_data_source;
        }

        component.properties = {
            titleSections: [
                {
                    type: 'text',
                    value: title
                        ? title
                        : `%{service_icon} ${getSubCategoryName(sub_category_id, nested_sub_category_id)}`,
                },
            ],
            ...(!isEmpty(metadata) ? { metadata } : {}),
        };
    }
};

export const getFullPersonalizedContent = (sectionNames, personalizedContent, lazyFetchedPersonalizedData) => {
    const [eagerSectionName, lazySectionName] = sectionNames;

    if (sectionNames.length === 1) {
        return personalizedContent?.[eagerSectionName] ?? [];
    }

    const firstLazySectionGigs = personalizedContent?.[lazySectionName]?.[0]?.items?.gigs;
    const isLocalizedLazySection = firstLazySectionGigs?.length > 0 && firstLazySectionGigs?.[0]?.translatedTitle;
    const fullPersonalizedContentFromConsumer = [
        ...(personalizedContent?.[eagerSectionName] ?? []),
        ...(personalizedContent?.[lazySectionName] ?? []),
    ];

    if (isLocalizedLazySection || !lazyFetchedPersonalizedData) {
        return fullPersonalizedContentFromConsumer;
    }

    return [
        ...(personalizedContent?.[eagerSectionName] ?? []),
        ...(lazyFetchedPersonalizedData?.[lazySectionName] ?? []),
    ];
};

export const getExcludedBadges = (component) => {
    const carouselName = component.name;

    return carouselNameToExcludedBadges[carouselName] ?? [];
};

export const getCarouselHeight = (component) => {
    if (component.type === 'roles_carousel') {
        return ROLES_SLIDING_CAROUSEL_HEIGHT;
    }

    return DYNAMIC_GIG_CARD_CAROUSEL_HEIGHT;
};
